import { useMutation, useQueryClient } from "@tanstack/react-query"
import { getSeamHttpClient } from "./use-seam-client"
import { DevicesSimulateDisconnectParameters } from "@seamapi/http"

export const useDisconnectDevice = () => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async ({
      workspace_id,
      ...params
    }: DevicesSimulateDisconnectParameters & { workspace_id: string }) => {
      const client = getSeamHttpClient(workspace_id)
      const result = await client.devices.simulate.disconnect(params)
      return result
    },
    onSuccess: (_, params) => {
      qc.invalidateQueries({ queryKey: ["devices", params.workspace_id] })
    },
  })
}
